import { createContext, useContext, type ReactNode } from 'react';
import type { DocumentPermission } from '../types';

interface DocumentPermissionContextValue {
  permission: DocumentPermission;
  isAdmin: boolean;
}

const DocumentPermissionContext = createContext<DocumentPermissionContextValue | undefined>(
  undefined,
);

export function DocumentPermissionProvider({
  permission,
  children,
}: {
  permission: DocumentPermission;
  children: ReactNode;
}) {
  return (
    <DocumentPermissionContext.Provider value={{ permission, isAdmin: permission === 'admin' }}>
      {children}
    </DocumentPermissionContext.Provider>
  );
}

export function useDocumentPermission(): DocumentPermissionContextValue {
  const context = useContext(DocumentPermissionContext);
  if (context === undefined) {
    throw new Error('useDocumentPermission must be used within a DocumentPermissionProvider');
  }
  return context;
}


